module.exports = __webpack_public_path__ + "img/156.cb1e0bfe.jpg";